// TODO: use GonConfigIncludable to pass tiles and supported locales from server to client

import { tiles } from '../../../config/settings/map.yml'
import { supported as supportedLocales } from '../../../config/settings/locale.yml'

export { tiles, supportedLocales }
export default { tiles, supportedLocales }
